import Dropdown from "antd/lib/dropdown";
import Menu from "antd/lib/menu";
import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { getImageBaseUrl } from "../../services/s3-utils";
import user from "../../assets/user.svg";
import { useLogout } from "../../hooks/useLogout";

function UserMenu(props) {
  const qalortUser = useSelector((state) => state.user.userData);
  const logoutHandler = useLogout();

  const logout = () => {
    logoutHandler();
  };

  const items = [
    {
      key: "4",
      label: (
        <span className="pointer text-dark py-3">
          <Link to="/dashboard">
            <p className="text-dark mb-0 flex py-2">
              <img
                src={`${getImageBaseUrl}/assets/dashboard.svg`}
                alt=""
                className="mr-2"
              />
              Dashboard
            </p>
          </Link>
        </span>
      ),
      forMentorsOnly: false,
    },
    {
      key: "1",
      label: (
        <span className="pointer text-dark py-3">
          <Link to="/calendar">
            <p className="text-dark mb-0 flex py-2">
              <img
                src={`${getImageBaseUrl}/assets/calendar_.svg`}
                alt=""
                className="mr-2"
              />
              Calendar
            </p>
          </Link>
        </span>
      ),
      forMentorsOnly: false,
    },

    {
      key: "6",
      label: (
        <span className="pointer text-dark py-3">
          <Link to={`/mentor/${qalortUser.username}`}>
            <p className="text-dark mb-0 flex py-2">
              <img src={user} alt="" className="mr-2 w-[18px] h-5" />
              My Profile
            </p>
          </Link>
        </span>
      ),
      forMentorsOnly: true,
    },
    {
      key: "3",
      label: (
        <span className="pointer text-dark py-3">
          <Link to="/settings/profile">
            <p className="text-dark mb-0 flex py-2">
              <img
                src={`${getImageBaseUrl}/assets/cog.svg`}
                alt=""
                className="mr-2"
              />
              Settings
            </p>
          </Link>
        </span>
      ),
      forMentorsOnly: false,
    },
    {
      key: "5",
      label: (
        <span data-testid="logout" onClick={logout} className="py-3">
          <p className="text-dark mb-0 flex py-2">
            <img
              src={`${getImageBaseUrl}/assets/logout.svg`}
              alt=""
              className="mr-2"
            />
            Logout
          </p>
        </span>
      ),
      forMentorsOnly: false,
    },
  ];

  const menu = (
    <Menu
      style={{ overflow: "auto", minWidth: 200 }}
      items={
        qalortUser.user_type === "learner"
          ? items.filter((i) => i.forMentorsOnly === false)
          : items
      }
    />
  );

  return (
    <div className="flex items-center">
      <Dropdown overlay={menu} placement="bottomLeft">
        <div className="mobile-none">
          <div className="flex items-center gap-[11px]">
            <img
              src={
                qalortUser?.profile ||
                qalortUser?.profile_image ||
                `${getImageBaseUrl}/assets/avatar.svg`
              }
              className="w-6 h-6 lg:w-12 lg:h-12 rounded-full"
              alt=""
            />
            <span
              data-testid="full_name"
              id="full_name"
              className="text-tint p-xs leading-[25px] [@media(min-width:1165px)]:flex hidden capitalize"
            >
              {!!qalortUser?.full_name ? qalortUser.full_name : ""}
            </span>
            <img
              src={`${getImageBaseUrl}/assets/caret-down.svg`}
              className="ml-1 w-2.5 [@media(min-width:1165px)]:flex hidden"
              alt=""
            />
          </div>
        </div>
      </Dropdown>
    </div>
  );
}

export default UserMenu;
